export const MediaTypes = {
	AI: 'AI_GENERATED',
	USER: 'USER_UPLOADED',
} as const;

export type MediaType = (typeof MediaTypes)[keyof typeof MediaTypes];
